import React from "react";
import './EGM.css'

import useMeta from "../../../hooks/useMeta";

import { Link } from "react-router-dom";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

const EGM = () => {

    useMeta({
        title: 'Marvel-decor-EGM | Marvel Blinds',
        description: null,
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/marvel-decor-egm`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Marvel-decor-EGM',
            description:
                "Notice of EGM_15_03_2025 Attendance Slip Proxy Form",
            url: `${process.env.REACT_APP_WEBSITE_URL}/marvel-decor-egm`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="EGM-pg-container">
                <h2 className="EGM-pg-title">Marvel-decor-EGM</h2>
                <table className="ENG-pg-content-table">
                    <tbody>
                        <tr>
                            <td className="even-row ">
                                <Link target="__blank" to="/Documnets/NoticeofEGM_15_03_2025.pdf">
                                    Notice of EGM_15_03_2025
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/AttendanceSlip.pdf">
                                    Attendance Slip
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Proxy_Form.pdf">
                                    Proxy Form
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default EGM;